export const expandedDrawerWidth = '190px';

export const collapsedDrawerWidth = '60px';
